import React from 'react';
import { motion } from 'framer-motion';
import { Download, Edit3, BarChart2 } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: Download,
    title: 'Accedé a la plantilla',
    description: 'Recibís el acceso inmediato a tu correo después de la compra.'
  }, {
    icon: Edit3,
    title: 'Cargá tus datos',
    description: 'Ingresá tus ingresos, gastos, ahorros y deudas en las celdas indicadas.'
  }, {
    icon: BarChart2,
    title: 'Visualizá tu situación',
    description: 'Automáticamente verás gráficos y resúmenes de tu estado financiero.'
  }];
  return <section className="py-20 bg-white" data-id="element-86">
      <div className="container mx-auto px-4 md:px-6" data-id="element-87">
        <div className="text-center mb-16" data-id="element-88">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4" data-id="element-89">
            ¿Cómo funciona?
          </h2>
          <p className="text-stone-600" data-id="element-90">
            Tres pasos simples para pasar del caos al orden.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-91">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-stone-200 -z-10" data-id="element-92" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="flex flex-col items-center text-center bg-white p-4" data-id="element-93">
              <div className="w-24 h-24 bg-[#fafaf9] rounded-full flex items-center justify-center border-4 border-white shadow-lg mb-6" data-id="element-94">
                <step.icon className="w-10 h-10 text-[#10b981]" data-id="element-95" />
              </div>
              <h3 className="text-xl font-bold text-stone-900 mb-3" data-id="element-96">
                {step.title}
              </h3>
              <p className="text-stone-600 max-w-xs" data-id="element-97">{step.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}